import { useMemo } from 'react';
import { useReplaceNode } from '../../useReplaceNode';
import { useDeleteNodeSelection } from '../useDeleteSelection/useDeleteSelection';
import { useNodeDisconnect } from '../useDisconnect/useDisconnect';
import { useNodeEdit } from '../useEdit/useEdit';
import { useNodeFocus } from '../useFocus/useFocus';
import { useNodeMove } from '../useMove/useMove';
import { useUpdateNodeHeight } from '../useUpdateHeight/useUpdateHeight';
export function useNodeHandlers({ props, state, derived, view, }) {
    const onMove = useNodeMove({
        nodeState: state.nodeState,
        setNodeState: state.setNodeState,
        relayedConnectorsRef: view.connections,
        relayedNodesRef: view.nodes,
    });
    const onEdit = useNodeEdit({
        props,
        state,
    });
    const onFocus = useNodeFocus({
        state,
        view,
    });
    const onUpdate = useReplaceNode({
        flowType: props.flow.type,
        setNodeState: state.setNodeState,
        extraData: props.flow.data,
        nodeAttributes: props.flow.attributes,
    });
    const onDisconnect = useNodeDisconnect({
        setNodeState: state.setNodeState,
        nodeAttributes: props.flow.attributes,
    });
    const onUpdateHeight = useUpdateNodeHeight({
        setNodeState: state.setNodeState,
        relayedConnectorsRef: view.connections,
        relayedNodesRef: view.nodes,
    });
    const onDeleteSelection = useDeleteNodeSelection({
        props,
        state,
        derived,
    });
    const handlers = useMemo(() => ({
        onMove,
        onEdit,
        onFocus,
        onUpdate,
        onUpdateHeight,
        onDisconnect,
        onDeleteSelection,
    }), [
        onMove,
        onEdit,
        onFocus,
        onUpdate,
        onUpdateHeight,
        onDisconnect,
        onDeleteSelection,
    ]);
    return handlers;
}
